import { action, makeObservable, observable } from 'mobx';

class GameStore {
  isBetsClosed = false;

  isRoundStarted = false;

  roundPhase = null;

  roundBetsByPhase = null;

  roundBetTypesInfo = null;

  gameStatus = null;

  constructor() {
    makeObservable(this, {
      isBetsClosed: observable,
      gameStatus: observable,
      isRoundStarted: observable,
      roundPhase: observable,
      roundBetsByPhase: observable,
      roundBetTypesInfo: observable,
      setIsBetsClosed: action.bound,
      setRoundPhase: action.bound,
      setGameStatus: action.bound,
      updateRoundBetsByPhase: action.bound,
      setRoundBetTypesInfo: action.bound,
      setIsRoundStarted: action.bound,
    });
  }

  setIsBetsClosed(arg) {
    this.isBetsClosed = arg;
  }

  setIsRoundStarted(arg) {
    this.isRoundStarted = arg;
  }

  setRoundPhase(arg) {
    this.roundPhase = arg;
  }

  setGameStatus(text) {
    this.gameStatus = text;
  }

  handleChangeStatus(text) {
    this.setGameStatus(text);
  }

  setRoundBetsByPhase(data) {
    this.roundBetsByPhase = data;
  }

  updateRoundBetsByPhase(data) {
    this.roundBetsByPhase = {
      ...this.roundBetsByPhase,
      [this.roundPhase]: data,
    };
  }

  setRoundBetTypesInfo(data) {
    this.roundBetTypesInfo = data;
  }

  resetRoundBetsByPhase() {
    this.roundBetsByPhase = null;
  }
}

export const gameStore = new GameStore();
